import React from 'react';
import { toChecksumAddress } from '../../../../../../utils/tronAddressToEthAddress';
import { useTranslation } from '../../../../../../hooks';
import { onAccountsChanged } from '../../../../../../utils/web3Provider';

interface IProps {
  selectedRawTxIndex: number;
  signatures?: string[];
  setSignatures: React.Dispatch<React.SetStateAction<string[]>>;
  onOperationClick: () => void;
  isWalletConnected: boolean;
  isButtonDisabled?: boolean;
}

const baseCellStyle: React.CSSProperties = {
  width: '100%',
  fontWeight: 'bold',
  borderRadius: '4px',
  margin: '12px 0px',
};

const SignedDisplay = ({ signature }: { signature: string }) => (
  <div
    style={{
      ...baseCellStyle,
      color: '#4CAF50',
    }}
  >
    {signature}
  </div>
);

interface OperationButtonProps {
  disabled?: boolean;
  onClick: () => void;
  title?: string;
}

export const OperationButton = ({ disabled, onClick, title }: OperationButtonProps) => {
  const { tc } = useTranslation();

  const style: React.CSSProperties = {
    ...baseCellStyle,
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '120px',
    backgroundColor: disabled ? 'rgba(0, 0, 0, 0.2)' : '#FFD100',
    color: disabled ? 'rgba(255,255,255,0.3)' : '#333',
    cursor: disabled ? 'none' : 'pointer',
    border: disabled ? '1px solid rgba(0, 0, 0, 0.12)' : 'none',
    boxShadow: disabled ? 'none' : undefined,
    opacity: disabled ? 1 : undefined,
  };

  return (
    <div style={style} onClick={disabled ? undefined : onClick}>
      {title || tc('sign')}
    </div>
  );
};

const SignOperationCell = (props: IProps) => {
  const {
    selectedRawTxIndex,
    signatures,
    setSignatures,
    onOperationClick,
    isWalletConnected,
    isButtonDisabled,
  } = props;
  const existingSignature = signatures?.[selectedRawTxIndex];

  onAccountsChanged(() => {
    setSignatures(() => {
      const newSignatures: string[] = [];
      return newSignatures;
    });
  });

  if (existingSignature) {
    return <SignedDisplay signature={existingSignature} />;
  }

  return (
    <OperationButton disabled={isButtonDisabled || !isWalletConnected} onClick={onOperationClick} />
  );
};

export default SignOperationCell;
